// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1nkIx","header":"MergedInvoice_header__2i0R6"};